<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'shared.modals.webcharge-detail.title' | translate }}
    </h5>
  </div>
  <div class="modal-body" *ngIf="webcharge">
    <table class="detail-table">
      <tr *ngIf="webcharge.cardNumber" class="key">
        <td class="key">{{ 'shared.modals.webcharge-detail.table.cardNumber' | translate }}</td>
        <td>{{ webcharge.cardNumber }}</td>
      </tr>
      <tr *ngIf="webcharge.reference" class="key">
        <td class="key">{{ 'shared.modals.webcharge-detail.table.reference' | translate }}</td>
        <td>{{ webcharge.reference }}</td>
      </tr>
      <tr *ngIf="webcharge.status" class="key">
        <td class="key">{{ 'shared.modals.webcharge-detail.table.status' | translate }}</td>
        <td>{{ webcharge.status }}</td>
      </tr>
      <tr *ngIf="webcharge.errorMessage" class="key">
        <td class="key">{{ 'shared.modals.webcharge-detail.table.errorMessage' | translate }}</td>
        <td>{{ webcharge.errorMessage }}</td>
      </tr>
      <tr *ngIf="webcharge.created" class="key">
        <td class="key">{{ 'shared.modals.webcharge-detail.table.created' | translate }}</td>
        <td>{{ webcharge.created | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>
      <tr *ngIf="webcharge.updated" class="key">
        <td class="key">{{ 'shared.modals.webcharge-detail.table.updated' | translate }}</td>
        <td>{{ webcharge.updated | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>
    </table>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" type="button" [disabled]="!webcharge || !webcharge.payment" (click)="onShowPayment()">
      {{ 'shared.modals.webcharge-detail.buttons.payment' | translate }}
    </button>
    <button class="btn btn-primary" ngbAutofocus type="button" (click)="onCloseModal()">
      {{ 'shared.modals.webcharge-detail.buttons.close' | translate }}
    </button>
  </div>
</div>
